import {Link} from 'react-router-dom'
import {useTranslation} from 'react-i18next'
import {Button} from '@/components/ui/button'
import {PorQue} from '@/components/ui/por-que'
import type {ResumenCola} from '@/lib/bateria-cola'

/** G6: por encima del 40 % de ítems dudosos la cola no abre y ofrece primero re-escanear. */
export function FrenoLote({
  resumen,
  volverA,
  onRevisarIgual,
}: {
  resumen: ResumenCola
  volverA: string
  onRevisarIgual: () => void
}) {
  const {t} = useTranslation()
  return (
    <section className="notice-amber space-y-3 rounded-lg px-5 py-4" data-testid="cola-freno">
      <p className="text-sm font-medium">
        {t('admin.bateria.cola.freno.titulo', {pct: Math.round(resumen.ratio_del_lote * 100)})}
      </p>
      <p className="flex flex-wrap items-center gap-2 text-sm">
        {t('admin.bateria.cola.freno.cuerpo')}
        <PorQue
          label={t('admin.bateria.cola.freno.porqueLabel')}
          testId="cola-freno-porque"
          contenidoTestId="cola-freno-porque-contenido">
          {t('admin.bateria.cola.freno.porque')}
        </PorQue>
      </p>
      <ul className="space-y-0.5" data-testid="cola-freno-reparto">
        {Object.entries(resumen.por_flag).map(([flag, count]) => (
          <li key={flag} className="font-mono text-[11px]">
            {t(`admin.bateria.flag.${flag}`, {defaultValue: flag})} · {count}
          </li>
        ))}
      </ul>
      <div className="flex flex-wrap gap-2">
        <Button asChild className="min-h-11 md:min-h-0" data-testid="cola-freno-reescanear">
          <Link to={`${volverA}?tab=personas`}>{t('admin.bateria.cola.freno.reescanear')}</Link>
        </Button>
        <Button
          variant="outline"
          className="min-h-11 md:min-h-0"
          data-testid="cola-freno-igual"
          onClick={onRevisarIgual}>
          {t('admin.bateria.cola.freno.igual')}
        </Button>
      </div>
    </section>
  )
}
